export const API_BASE_URL = "https://drjitu.bgoil.in/admin";
//export const API_BASE_URL = "http://127.0.0.1:8000";
